import { BigNumber, ethers } from "ethers";
import { useEffect, useState } from "react";
import Bep20Abi from "src/assets/abis/Bep20Abi.json";
import { BscTravaConfig, EthTravaConfig, FtmTravaConfig } from "src/config/balance/travaBalanceConfig";
import { useProviderContext } from "src/ether-utils/context/providerContext";
import { convertBigNumber } from "src/ether-utils/utils";

export default function useTravaBalance(accountAddress) {
  const [travaBalance, setTravaBalance] = useState({});

  const { bscProvider, ftmProvider, ethProvider } = useProviderContext();

  const _fetchTravaBalance = async (accountAddress, travaAddress, sTravaAddress, _provider) => {
    const travaContract = new ethers.Contract(travaAddress, Bep20Abi, _provider);
    const sTravaContract = new ethers.Contract(sTravaAddress, Bep20Abi, _provider);
    let balanceTrava = null;
    let balanceSTrava = null;
    try {
      balanceTrava = await travaContract.balanceOf(accountAddress);
      balanceSTrava = await sTravaContract.balanceOf(accountAddress);
      balanceTrava = BigNumber.from(balanceTrava);
      balanceSTrava = BigNumber.from(balanceSTrava);
    } catch (error) {
      balanceTrava = BigNumber.from("0");
      balanceSTrava = BigNumber.from("0");
    }
    return convertBigNumber(balanceSTrava.add(balanceTrava), 18, 2);
  };

  const _fetchAllTravaBalance = async (accountAddress) => {
    const { travaAddress: bscAddress, sTravaAddress: bscSAddress } = BscTravaConfig;
    const { travaAddress: ftmAddress, sTravaAddress: ftmSAddress } = FtmTravaConfig;
    const { travaAddress: ethAddress, sTravaAddress: ethSAddress } = EthTravaConfig;
    let [bscTrava, ftmTrava, ethTrava] = await Promise.all([
      _fetchTravaBalance(accountAddress, bscAddress, bscSAddress, bscProvider),
      _fetchTravaBalance(accountAddress, ftmAddress, ftmSAddress, ftmProvider),
      _fetchTravaBalance(accountAddress, ethAddress, ethSAddress, ethProvider),
    ]);
    return { bscTrava, ftmTrava, ethTrava };
  };

  useEffect(() => {
    if (bscProvider && ftmProvider && ethProvider) {
      _fetchAllTravaBalance(accountAddress)
        .then((data) => {
          setTravaBalance(data);
        })
        .catch((error) => {
          console.error("trava balance error: ", error);
        });
    }
  }, [bscProvider, ftmProvider, ethProvider, accountAddress]);

  return travaBalance;
}
